function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 5.25H5.5C5.35938 5.25 5.25 5.35938 5.25 5.5V6.5H10.75V5.5C10.75 5.35938 10.6406 5.25 10.5 5.25ZM4.5 6.5V5.5C4.5 4.95312 4.95312 4.5 5.5 4.5H10.5C11.0469 4.5 11.5 4.95312 11.5 5.5V10.5C11.5 11.0469 11.0469 11.5 10.5 11.5H5.5C4.95312 11.5 4.5 11.0469 4.5 10.5V6.5ZM10.75 10.5V7.25H7V10.75H10.5C10.6406 10.75 10.75 10.6406 10.75 10.5ZM6.25 10.75V7.25H5.25V10.5C5.25 10.6406 5.35938 10.75 5.5 10.75H6.25Z",
  fill: "currentColor"
});

function SvgViewTableIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewTableIcon);
export default __webpack_public_path__ + "static/media/view-table-icon.b1731a37.svg";
export { ForwardRef as ReactComponent };